export default __webpack_public_path__ + "static/media/timer.6dadf544.svg";